export default {"src":"/fly/_next/static/media/carousel-arrow-left.8db54076.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};